module.exports = __webpack_public_path__ + "img/appleshare_v2.542de9e8.png";